import { render, staticRenderFns } from "./Economic.vue?vue&type=template&id=bce2e146&"
import script from "./Economic.vue?vue&type=script&lang=js&"
export * from "./Economic.vue?vue&type=script&lang=js&"
import style0 from "./Economic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports